import React from 'react'

import ChatMessageContent from '@components/chat-message-content/chat-message-content.component'
import ChatMessageReference from '@components/chat-message-reference/chat-message-reference.component'


const ChatMessageFilter = (props) => {
  const { message } = props
  const { type } = message

  switch (type) {
  case 'reference':
    /*
     * DEV-5188: always render ChatMessageReference so its useFirestoreConnect
     * subscribes to the referenced doc immediately, even for rows that are
     * off-screen above the initial scroll. Previously this was gated on
     * InView's isVisible, which meant rows the user never scrolled into
     * view stayed stuck on an ~800px ReferenceLoader skeleton — leaving
     * the top of the Messages history as a stack of ghost tall placeholders.
     */
    return <ChatMessageReference {...props} />
  default:
    return (
      <div>
        <ChatMessageContent message={message} />
      </div>
    )
  }
}

export default ChatMessageFilter
